function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.598 11.841c0 3.26 1.202 6.16 3.781 7.242.423.177.802.006.925-.475.085-.333.287-1.172.377-1.521.124-.476.076-.642-.266-1.057-.743-.9-1.219-2.066-1.219-3.717 0-4.79 3.492-9.079 9.093-9.079 4.96 0 7.684 3.11 7.684 7.265 0 5.465-2.356 10.078-5.855 10.078-1.932 0-3.378-1.64-2.914-3.652.555-2.4 1.63-4.992 1.63-6.726 0-1.551-.812-2.845-2.49-2.845-1.976 0-3.562 2.097-3.562 4.906 0 1.79.589 3 .589 3L5.995 25.587c-.705 3.066-.106 6.824-.055 7.204.03.224.311.278.439.108.182-.244 2.534-3.225 3.334-6.203.226-.843 1.299-5.21 1.299-5.21.642 1.256 2.517 2.363 4.511 2.363 5.937 0 9.965-5.555 9.965-12.991C25.488 5.236 20.848 0 13.796 0 5.022 0 .598 6.457.598 11.841z",
  fillRule: "evenodd"
});

function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 33",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgPinterest;